export default __webpack_public_path__ + "static/media/Portada_Clientes.d55aec30.png";